/**
 * Removes an item from sessionStorage with the specified key.
 * @param {string} key - The key of the item to remove.
 */
export default {
  unlock(key) {
    sessionStorage.removeItem(key)
  },

  /**
   * Locks a key in sessionStorage for a specified number of seconds.
   * @param {string} key - The key to lock.
   * @param {number} seconds - The number of seconds to lock the key for.
   * @returns {boolean} - Returns true if the key was successfully locked, or false if it is already locked.
   */
  lock(key, seconds) {
    const lockTimestamp = sessionStorage.getItem(key)

    if (lockTimestamp === null || Date.now() - parseInt(lockTimestamp) >= seconds * 1000) {
      sessionStorage.setItem(key, Date.now().toString())
      return true
    }

    return false
  }
}
